import React, {useState, useEffect} from 'react';
import Chart from 'react-apexcharts';
import Title from '../../../../components/Title';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import DrawTable from '../../../../components/DrawTable';
import DataCard from '../DataCard';
import {
  AnnotationsMonth,
  AnnotationsPremiums,
  getMonthName,
  getPlanName,
  months,
  premiuns,
  responsive,
  responsiveCards,
  responsiveMedium,
  returnTotalValues,
  returnTotalValuesPremium,
  returnValuesPremium,
  returnValuesTotalPremium,
} from '../../service/utils';
import dashboardService from '../../service';
import {KeyboardDatePicker} from '@material-ui/pickers';
import DrawTableDash from '../../../../components/DrawTableDash';
import {GetAppOutlined} from '@material-ui/icons';
import {styles} from './styles';
import {CustomSelect} from './components/CustomSelect';

const CategoriesItem = () => {
  const colorMap = {
    Meditações: '#316570',
    Conexão: '#ff8795',
    Yoga: '#ffac1c',
    Fé: '#ffdc00',
    Músicas: '#38b2f7',
    Exercícios: '#4cc836',
  };

  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [screenData, setScreenData] = useState([]);
  const [filters, setFilters] = useState({
    platform: null,
    currentAccountType: null,
    currentPremium: null,
  });

  const GetData = async () => {
    setLoading(true);

    const response = await dashboardService.getCategories({
      startDate,
      endDate,
      filters: {
        platform: filters.platform || null,
        currentAccountType: filters.currentAccountType || null,
        currentPremium: filters.currentPremium || null,
      },
    });
    setScreenData(response.data || []);

    setLoading(false);
  };

  useEffect(() => {
    GetData();
  }, [startDate, endDate, filters]);

  const categories = screenData.map(item => item.category);

  const seriesScreens = [
    {
      name: 'Acessos',
      data: screenData.map(item => item.total),
    },
  ];

  const colors = categories.map(cat => colorMap[cat] || '#c6c6c6');

  return (
    <div
      style={{
        margin: 15,
        marginTop: 25,
        padding: 20,
        backgroundColor: '#fff',
        borderRadius: 10,
      }}>
      <div>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          style={{marginBottom: 20}}>
          Categorias
        </Typography>

        <div style={styles.flex}>
          <CustomSelect
            title="Plataforma"
            values={[
              {value: null, label: 'Todos'},
              {value: 'android', label: 'Android'},
              {value: 'ios', label: 'IOS'},
            ]}
            value={filters.platform}
            setValue={event =>
              setFilters({
                ...filters,
                platform: event,
              })
            }
          />

          <CustomSelect
            title="Assinantes"
            values={[
              {value: null, label: 'Todos'},
              {value: 'subscriber', label: 'Sim'},
              {value: 'free', label: 'Não'},
            ]}
            value={filters.currentAccountType}
            setValue={event =>
              setFilters({
                ...filters,
                currentAccountType: event,
              })
            }
          />

          <CustomSelect
            title="Tipo de plano"
            values={[
              {value: null, label: 'Todos'},
              {value: 'N', label: 'Novo'},
              {value: 'F', label: 'Free'},
              {value: 'M', label: 'Mensal'},
              {value: 'Y', label: 'Anual'},
            ]}
            value={filters.currentPremium}
            setValue={event =>
              setFilters({
                ...filters,
                currentPremium: event,
              })
            }
          />

          <div style={styles.flexEnd}>
            <div style={styles.datePicker}>
              <KeyboardDatePicker
                placeholder="Selecione data inicial"
                value={startDate}
                onChange={dateForm => {
                  const newStartDate = new Date(dateForm);

                  if (newStartDate > endDate) {
                    setEndDate(newStartDate);
                  }

                  setStartDate(newStartDate);
                }}
                maxDate={endDate}
                format="DD/MM/YYYY"
              />
            </div>

            <div style={styles.datePicker}>
              <KeyboardDatePicker
                placeholder="Selecione data final"
                value={endDate}
                onChange={dateForm => {
                  const newEndDate = new Date(dateForm);

                  if (newEndDate < startDate) {
                    setStartDate(newEndDate);
                  }

                  setEndDate(newEndDate);
                }}
                minDate={startDate}
                format="DD/MM/YYYY"
              />
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="flex-col center-a center-b">
          <CircularProgress size={100} />
        </div>
      ) : (
        <Chart
          options={{
            chart: {
              type: 'bar',
              height: 350,
            },

            plotOptions: {
              bar: {
                horizontal: false,
                borderRadius: 4,
                distributed: true,
              },
            },

            colors: colors,

            xaxis: {
              categories: categories,
            },

            dataLabels: {
              enabled: true,
              formatter: (val, opts) => {
                return '';
              },
            },

            tooltip: {
              y: {
                formatter: (val, opts) => {
                  const index = opts.dataPointIndex;
                  const perc = (screenData[index].percentage * 100).toFixed(2);
                  return `${val} (${perc}%)`;
                },
              },
            },
          }}
          series={seriesScreens}
          type="bar"
          height={500}
        />
      )}
    </div>
  );
};

export default CategoriesItem;
